const v2 = `/v2`;

const authBasePrefix = `${v2}/Auth/`;
export const auth = {
  signin: () => `${authBasePrefix}signin`,
  signup: () => `${v2}/Registration`,
  forgot: () => `${authBasePrefix}forgot`,
  refreshToken: () => `${authBasePrefix}refresh`,
  authenticate: () => `${authBasePrefix}authenticate`,
};

const dashboardPrefix = `${v2}/Dashboard/`;
export const dashboard = {
  notifications: () => `${dashboardPrefix}notifications`,
  notificationDetail: (alertGuid: string) => `${dashboardPrefix}notifications/${alertGuid}/detailed`,
  summaries: () => `${dashboardPrefix}summaries`,
  spending: (currency: string) => `${dashboardPrefix}summaries/${currency}/spending`,
  expenseCategories: (currency: string) => `${dashboardPrefix}summaries/${currency}/expense-categories`,
  merchants: (currency: string) => `${dashboardPrefix}summaries/${currency}/merchants`,
  accountSummary: () => `${dashboardPrefix}GetAccountSummary`,
  paymentSummary: () => `${dashboardPrefix}GetPaymentSummary`,
};

const cardsBasePrefix = `${v2}/Cards/`;
export const cards = {
  getCards: () => `${cardsBasePrefix}`,
  getCard: (cardId: number) => `${cardsBasePrefix}${cardId}`,
  getCardsByAccounts: () => `${cardsBasePrefix}byaccounts`,
  blockCard: (cardId: number) => `${cardsBasePrefix}${cardId}/block`,
  freezeCard: (cardId: number) => `${cardsBasePrefix}${cardId}/freeze`,
  unfreezeCard: (cardId: number) => `${cardsBasePrefix}${cardId}/unfreeze`,
  activate: (cardId: number) => `${cardsBasePrefix}${cardId}/activate`,
  remindPin: (cardId: number) => `${cardsBasePrefix}${cardId}/remindPin`,
  updateLabel: (cardId: number) => `${cardsBasePrefix}${cardId}/label`,
  updateCategory: (cardId: number) => `${cardsBasePrefix}${cardId}/category`,
  updateLimit: (cardId: string) => `${cardsBasePrefix}${cardId}/limit`,
  reportLostStolen: (cardId: number) => `${cardsBasePrefix}${cardId}/reportLostStolen`,
  getLimits: (cardId: number) => `${cardsBasePrefix}${cardId}/limit`,
};

const transactionsBasePrefix = `${v2}/Transactions/`;
export const transactions = {
  getList: () => `${transactionsBasePrefix}GetList`,
  updateTransaction: () => transactionsBasePrefix,
  createReceiptTransaction: (refNum: string) => `${transactionsBasePrefix}${refNum}/receipt`,
  getReceiptTransaction: (refNum: string) => `${transactionsBasePrefix}receipt/${refNum}`,
  removeReceiptTransaction: (refNum: string) => `${transactionsBasePrefix}receipt/${refNum}`,
  // getTransactions: () => `${v1}/transactions`,
  // getTransactionsByAccounts: () => `${v1}/Transactions/byaccounts`,
  // receipt: (refNum: string) => `${v1}/Transactions/` + refNum + `/receipt`,
  // getReceipt: (id: string) => `${v1}/Transactions/receipt/` + id,
  // removeReceipt: (refNum: string) => `${v1}/Transactions/receipt/` + refNum,
};

const accountsBasePrefix = `${v2}/Accounts/`;
export const accounts = {
  getAccounts: () => `${accountsBasePrefix}GetAccounts`,
  getAccountsForIntegrations: () => `${accountsBasePrefix}GetAccountsForIntegrations`,
  getAccountById: () => `${accountsBasePrefix}GetAccountById`,
  updateDetails: () => `${accountsBasePrefix}UpdateAccountInfo`,
  updateMBSubscription: (accountId: number) => `${accountsBasePrefix}` + accountId + `/minimal-balance-subscription`,
  updateDASubscription: (accountId: number) => `${accountsBasePrefix}` + accountId + `/minimal-balance-subscription`,
  getCardAccountBalanceReport: () => `${accountsBasePrefix}GetCardAccountBalanceReport`,
  getPaymentAccountBalanceReport: () => `${accountsBasePrefix}GetPaymentAccountBalanceReport`,
  getBalance: (accountId: number) => `${accountsBasePrefix}${accountId}/balance`,
};

const usersBasePrefix = `${v2}/Users/`;
export const users = {
  getUsers: () => usersBasePrefix,
  getUser: (uId: string) => `${usersBasePrefix}${uId}`,
  updateUser: (id: string) => `${usersBasePrefix}${id}`,
  deleteUser: (uId: string) => `${usersBasePrefix}${uId}`,
  lockUser: (uId: string) => `${usersBasePrefix}${uId}/lock`,
  unLockUser: (uId: string) => `${usersBasePrefix}${uId}/unlock`,
  getAccountUsers: () => usersBasePrefix,
  updatePassword: () => `${usersBasePrefix}password`,
  getOneUser: (uId: string) => `${usersBasePrefix}${uId}`,
  addUserAccounts: () => `${usersBasePrefix}assign/accounts`,
  addUserCards: () => `${usersBasePrefix}assign/cards`,
  deleteUserAccounts: () => `${usersBasePrefix}disassociate/account`,
  deleteUserCards: () => `${usersBasePrefix}disassociate/card`,
  degenerateCode: () => `${usersBasePrefix}GenerateCode`,
};

const statementsBasePrefix = `${v2}/Statements/`;
export const statements = {
  getStatements: () => statementsBasePrefix,
  download: (id: string) => `${statementsBasePrefix}${id}/download`,
  downloadv1: () => `${statementsBasePrefix}downloadv1`,
  DownloadSepaStatement: () => `${statementsBasePrefix}DownloadSepaStatement`,
};

const miscBasePrefix = `${v2}/Misc/`;
export const misc = {
  getCountries: () => `${miscBasePrefix}GetCountries`,
  getCurrencies: () => `${miscBasePrefix}GetCurrencies`,
  getAvailableCurrencies: () => `${miscBasePrefix}GetAvailableCurrencies`,
  getProducts: () => `${miscBasePrefix}products`,
  getBankInformation: () => `${miscBasePrefix}GetBankInformation`,
  getCountryProvinces: () => `${miscBasePrefix}GetCountryProvinces`,
  getTransferCurrencies: () => `${miscBasePrefix}GetTransferCurrencies`,
};

const messageBasePrefix = `${v2}/Messages/`;
export const messages = {
  getThreads: () => `${messageBasePrefix}threads`,
  getThreadsMessages: (groupId: string) => `${messageBasePrefix}threads/${groupId}`,
  readThread: () => `${messageBasePrefix}read`,
  deleteThread: (groupId: string) => `${messageBasePrefix}${groupId}`,
  addAttachments: (messageId: string) => `${messageBasePrefix}${messageId}/attachments`,
  addMessage: () => messageBasePrefix,
  downloadAttachment: (fileId: string, messageId: string) => `${messageBasePrefix}${messageId}/attachments/${fileId}`,
  removeAttachment: (fileId: string, messageId: string) => `${messageBasePrefix}${messageId}/attachments/${fileId}`,
};

const profileBasePrefix = `${v2}/Profile/`;
export const profile = {
  getProfile: () => `${profileBasePrefix}`,
  getProfileFeatures: () => `${profileBasePrefix}features`,
};

const reportBasePrefix = `${v2}/Reports/`;
export const reports = {
  generateCardAccountBalanceReport: () => `${reportBasePrefix}GenerateCardAccountBalanceReport`,
  generatePaymentAccountBalanceReport: () => `${reportBasePrefix}GeneratePaymentAccountBalanceReport`,
  generateTransactionReport: () => `${reportBasePrefix}GenerateTransactionReport`,
  generatePaymentReport: () => `${reportBasePrefix}GeneratePaymentReport`,
};

const paymentBasePrefix = `${v2}/Payment/`;
export const payments = {
  getById: () => `${paymentBasePrefix}GetById`,
  getPaymentsByAccounts: () => `${paymentBasePrefix}GetPaymentsByAccounts`,
  getPaymentsByRecipientId: () => `${paymentBasePrefix}GetPaymentsByRecipientId`,
  getGenerateReceiptById: () => `${paymentBasePrefix}GenerateReceiptById`,
};

const alertsBasePrefix = `${v2}/AlertSubscriptions/`;
export const alerts = {
  minimalBalanceAdd: () => `${alertsBasePrefix}subscription-minimal-balance`,
  declinedAuthAdd: () => `${alertsBasePrefix}subscription-declined-auth`,
  minimalBalanceUpdate: (subscriptionId: string) => `${alertsBasePrefix}subscription-minimal-balance/` + subscriptionId,
  declinedAuthUpdate: (subscriptionId: string) => `${alertsBasePrefix}subscription-declined-auth/` + subscriptionId,
  deleteSubscription: (subscriptionId: string) => `${alertsBasePrefix}subscription/` + subscriptionId,
  deleteRecipients: (subscriptionId: string) => `${alertsBasePrefix}subscription-recipients/` + subscriptionId,
};

const integrationsBasePrefix = `${v2}/Integrations/`;
export const integrations = {
  get: () => integrationsBasePrefix,
  connect: (service: string) => `${integrationsBasePrefix}connect/${service}`,
  confirm: (service: string, code: string) => `${integrationsBasePrefix}connect/${service}/callbackcode/${code}`,
  disconnect: (service: string) => `${integrationsBasePrefix}disconnect/${service}`,
  disconnectAccount: (service: string, accountId: string) => `${integrationsBasePrefix}disconnect/${service}/${accountId}`,
  getXeroAccountTypes: () => `${v2}/Integrations/xero/accounttypes`,
  setXeroAccountType: (accountId: string, accountType: string) => `${integrationsBasePrefix}xero/account/${accountId}/accounttypes/${accountType}`,
};

const recipientsPrefix = `${v2}/Recipients/`;
export const recipients = {
  getById: () => `${recipientsPrefix}GetById`,
  getList: () => `${recipientsPrefix}GetList`,
  getRecent: () => `${recipientsPrefix}GetRecent`,
  create: () => `${recipientsPrefix}`,
  update: () => `${v2}/Recipients`,
  delete: (id: string) => `${recipientsPrefix}${id}`,
  getMandatoryFields: () => `${recipientsPrefix}GetRecipientMandatoryFields`,
};

const transferRequestPrefix = `${v2}/TransferRequest/`;
export const transferRequests = {
  getFee: () => `${transferRequestPrefix}GetFee`,
  getList: () => `${transferRequestPrefix}GetList`,
  create: () => `${transferRequestPrefix}Create`,
  update: () => `${transferRequestPrefix}Update`,
  updateStatus: () => `${transferRequestPrefix}UpdateStatus`,
  getDocuments: () => `${transferRequestPrefix}GetDocuments`,
  downloadDocument: () => `${transferRequestPrefix}DownloadDocument`,
  createDocument: () => `${transferRequestPrefix}CreateDocument`,
  deleteDocument: () => `${transferRequestPrefix}DeleteDocument`,
  getLimits: () => `${transferRequestPrefix}GetTransferLimits`,
  getTransferReasons: () => `${transferRequestPrefix}GetTransferReasons`,
  getFxRate: () => `${transferRequestPrefix}GetFxRate`,
};
